import { useState } from 'react'

import { Modal } from '@/components/Modal'
import { Button } from '@/components/Button'
import { MemberItem } from '@/components/MemberItem'
import { Spinner } from '@/components/Spinner'
import { useOrganizationMembers } from '@/hooks/useOrganizationMembers'
import { useDeleteOrgMember } from '@/hooks/useDeleteOrgMember'
import { useToast } from '@/hooks/Toast'
import { useUser } from '@/hooks/useUser'

export const OrganizationMembers = () => {
  const { user } = useUser()
  const { 
    data: members, 
    isLoading, 
    isFetchingNextPage, 
    hasNextPage, 
    loadMoreRef 
  } = useOrganizationMembers({
    organizationId: user?.organizationId,
  })
  const [removingMember, setRemovingMember] = useState<any | null>(null)
  const removeMemberMutation = useDeleteOrgMember()
  const toast = useToast()

  const handleRemove = async () => {
    try {
      await removeMemberMutation.mutateAsync({
        organizationId: removingMember.organizationId,
        memberId: removingMember.id,
      })

      setRemovingMember(null)
    } catch (error) {
      toast.error('Something went wrong. Try again?')
    }
  }

  if (isLoading) {
    return <Spinner />
  }

  return (
    <div>
      {members.map((member) => (
        <MemberItem
          key={member.id}
          member={member}
          isMe={!!user?.userIds.includes(member.userId)}
          onRemove={() => setRemovingMember(member)}
        />
      ))}
      {hasNextPage && (
        <div ref={loadMoreRef} style={{ display: 'flex', justifyContent: 'center', padding: '20px 0' }}>
          {isFetchingNextPage && <Spinner />}
        </div>
      )}

      {removingMember && (
        <Modal
          title="Remove Member"
          description={`Are you sure you want to remove "${removingMember.name}" from the organization?`}
          open={!!removingMember}
          onClose={() => setRemovingMember(null)}
        >
          <Button
            variant="destructive"
            disabled={removeMemberMutation.isPending}
            onClick={handleRemove}
          >
            Yes, Remove
          </Button>
        </Modal>
      )}
    </div>
  )
}
